// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"0634faa5","280":"59f4bfbe","573":"548457e9","588":"0db2e65b","683":"a869cd0e","784":"651a3d1a","787":"bed44058"}[chunkId] + ".chunk.js";
};